import { Styles } from 'jss';
import merge from 'lodash/merge';

import { commonStyles } from './common.styles';
import { AdSlotFormatSizeMap } from '../../constants';
import { StylesDataType } from '../../types';

export const imageStyles: Styles<string, StylesDataType> = {
  outerContainer: (data: StylesDataType): object => merge({}, {
    ...commonStyles.outerContainer(data),
    maxWidth: AdSlotFormatSizeMap[data.format].width,
    maxHeight: AdSlotFormatSizeMap[data.format].height,
  }, data.style?.outerContainer ?? {}),

  container: (data: StylesDataType): object => merge({}, {
    ...commonStyles.container(data),
  }, data.style?.container ?? {}),

  heading: (data: StylesDataType): object => merge({}, {
    display: 'none !important',
  }, data.style?.heading ?? {}),

  listItemImgLink: (data: StylesDataType): object => merge({}, {
    display: 'inline-block !important',
    textDecoration: 'none !important',
  }, 'itemImgLink' in data.style ?  data.style?.itemImgLink : {}),

  listItemImg: (data: StylesDataType): object => merge({
    verticalAlign: 'middle !important',
    borderStyle: 'none !important',
    maxWidth: AdSlotFormatSizeMap[data.format].width,
    maxHeight: AdSlotFormatSizeMap[data.format].height,
  }, {}, 'itemImg' in data.style ? data.style?.itemImg : {}),

  footer: (data: StylesDataType): object => merge({}, {
    ...commonStyles.footer(data),
    position: 'absolute !important',
    bottom: 0,
    right: 0,
  }, data.style?.footer ?? {}),

  footerLeft: (data: StylesDataType): object => merge({}, {
    display: 'none !important',
  }, data.style.footerLeft ?? {}),

  footerRight: (data: StylesDataType): object => merge({}, {
    ...commonStyles.footerRight(data),
    padding: 10,
  }, data.style.footerLeft ?? {}),
}
